import { Popover } from 'antd';
import { Bill } from 'features/ticketList/services/types/api';
import userActions from 'features/user/services/actions';
import { customerEditorRef } from 'features/user/widgets/WaitingList/CustomerEditor';
import {
  CustomerInfoPopoverUI,
  IconInfo,
  useCustomerInfoPopover,
} from 'features/user/widgets/WaitingList/WalkIn/components/CustomerName';
import { useAppDispatch } from 'store/hooks';
import styled from 'styled-components';
import { formatPhone, maskPhone } from 'utils/formatPhone';

type CustomerBoxProps = {
  id: string;
  extraData: Bill;
};

const CustomerBox = ({ id, extraData }: CustomerBoxProps) => {
  const dispatch = useAppDispatch();
  const { customerInfo, customerDetailLoading, viewCustomer, open, setOpen, handleCheckPassBeforeView, dataPin } =
    useCustomerInfoPopover(id);

  const onOpenChange = (val: boolean) => handleCheckPassBeforeView(val);
  const onEdit = () => {
    customerEditorRef.current?.openWithId(customerInfo.customerId, {
      addon: customerInfo,
      onSuccess: (data) => {
        if (data) {
          dispatch(userActions.syncCustomerInfo(data));
        }
      },
    });
    setOpen(false);
  };

  return (
    <WrapperInfoBox>
      <div className='content'>
        <Popover
          placement='rightTop'
          title={null}
          content={
            <div onClick={(e) => e.stopPropagation()}>
              <CustomerInfoPopoverUI
                loading={customerDetailLoading}
                customerInfo={customerInfo}
                onOpenChange={onOpenChange}
                onEdit={onEdit}
                dataPin={dataPin}
              />
            </div>
          }
          open={open}
          trigger={'click'}
          onOpenChange={onOpenChange}
          overlayInnerStyle={{ padding: 16, borderRadius: 8, background: '#E4F4F6' }}
        >
          <button
            style={{ flex: 1, overflow: 'hidden', display: 'flex', alignItems: 'center', gap: '4px' }}
            type='button'
            onClick={viewCustomer}
          >
            {!!id && <IconInfo />}
            <div className='customer-name'>
              {extraData.customerName || 'Unknown Customer'}-{' '}
              {extraData.customerPhone ? maskPhone(extraData.customerPhone) : formatPhone('00000000000')}
            </div>
          </button>
        </Popover>
      </div>
    </WrapperInfoBox>
  );
};

export default CustomerBox;

const WrapperInfoBox = styled.div`
  flex: 1;
  position: relative;
  align-self: stretch;
  .content {
    display: flex;
    align-items: center;
  }

  .customer-name {
    color: #1d2129;
    font-family: Poppins;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`;
